import React from 'react';
import { Link } from 'react-router-dom';
import {
  LuArrowUpRight,
  LuBookOpen,
  LuBookmark,
  LuGraduationCap,
  LuLibrary,
  LuRefreshCw,
  LuZap,
} from 'react-icons/lu';
import { APP_JOURNEY } from '../../config/appJourneyContent';

const STEP_ICONS = {
  library: LuLibrary,
  learn: LuBookOpen,
  save: LuBookmark,
  study: LuGraduationCap,
  review: LuRefreshCw,
  practice: LuZap,
};

/** End-to-end product loop with optional “you are here” step. */
export default function HubAppJourney({ highlight }) {
  const { lead, steps } = APP_JOURNEY;

  return (
    <section className="hub-app-journey" aria-labelledby="hub-app-journey-title">
      <div className="hub-app-journey-head">
        <h4 id="hub-app-journey-title" className="hub-app-journey-title">
          How QnaRead works end to end
        </h4>
        <p className="hub-app-journey-lead">{lead}</p>
      </div>
      <ol className="hub-app-journey-steps">
        {steps.map((step, index) => {
          const isHere = highlight && step.id === highlight;
          const Icon = STEP_ICONS[step.id] || LuBookOpen;
          return (
            <li
              key={step.id}
              className={`hub-app-journey-step${isHere ? ' hub-app-journey-step--here' : ''}`}
            >
              {index > 0 ? <span className="hub-app-journey-rail" aria-hidden /> : null}
              <Link to={step.path} className="hub-app-journey-step-link">
                <span className="hub-app-journey-step-icon" aria-hidden>
                  <Icon />
                </span>
                <span className="hub-app-journey-step-body">
                  <span className="hub-app-journey-step-top">
                    <span className="hub-app-journey-step-label">{step.label}</span>
                    <LuArrowUpRight className="hub-app-journey-step-go" aria-hidden />
                  </span>
                  <span className="hub-app-journey-step-text">{step.text}</span>
                  {isHere ? (
                    <span className="hub-app-journey-you-are-here">You are here</span>
                  ) : null}
                </span>
                <span className="hub-app-journey-step-index" aria-hidden>
                  {index + 1}
                </span>
              </Link>
            </li>
          );
        })}
      </ol>
    </section>
  );
}
